(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-no-products-found"] && !Shopify.designMode) return;
  try {
    const holder = document.getElementById("searchanise-widget-holder");
const temp_widget = document.getElementById("0E0K2K2E0A1L2E9");
const container = document.querySelector('.snize-ac-results-content') || document.body;
var flag = false;

document.addEventListener("DOMContentLoaded", function () {

  setTimeout(function () {
    document
      ?.getElementById("searchanise-widget-holder")
      ?.setAttribute("style", "display: none");
  }, 2500);
});

const productObserver2 = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;

      const isNoResults = node.classList?.contains('snize-noresults-html');
      const noResultsInside = node.querySelector?.('.snize-noresults-html');

      if (isNoResults || noResultsInside) {
        const target = isNoResults ? node : noResultsInside;
        const span_value = document.getElementById("span-item-search");
        const item_search = document.getElementById("Search-In-Modal");

        span_value.innerText = item_search.value;
        target.insertAdjacentElement('afterend', holder);
        holder.classList.remove("snize-hidden");

        if(!flag){
          holder.removeAttribute("style");
          flag = true;
        }
      }
    }
  }
});

productObserver2.observe(container, {
  childList: true,
  subtree: true
});

console.log('Observer montado sobre', container);

function observarVisibilidad() {
  const elemento = document.querySelector('.snize-ac-results-columns');
  
  if (!elemento) {
    setTimeout(observarVisibilidad, 500);
    return;
  }

  // Función para comprobar si es visible
  const esVisible = (el) => {
    const estilos = window.getComputedStyle(el);
    return estilos.display !== 'none' 
        && estilos.visibility !== 'hidden' 
        && estilos.opacity !== '0'
        && el.offsetParent !== null;
  };

  let visibleAnterior = esVisible(elemento);

  // Crear el observer
  const observer = new MutationObserver((mutaciones) => {
    const visibleAhora = esVisible(elemento);
    
    if (visibleAhora !== visibleAnterior) {
      visibleAnterior = visibleAhora;
      
      // Disparar tu lógica
      if (visibleAhora) {
        holder.classList.add("snize-hidden");
      } else {
        
      }
    }
  });

  // Observar cambios en atributos (style, class) y en el subárbol
  observer.observe(elemento, {
    attributes: true,
    attributeFilter: ['style', 'class'],
    subtree: false
  });

  return observer;
}

observarVisibilidad();

function prepareWidget(){
  document.addEventListener("DOMContentLoaded", function () {
  const waitForSearchanise = setInterval(function () {
    if (window.Searchanise && window.Searchanise.GetWidgets) {
      clearInterval(waitForSearchanise);
      window.Searchanise.GetWidgets().start();
    }
  }, 100);
  });
}
  } catch(e) { console.error(e); }
})();

})();
